import React, { memo, useContext } from 'react'
import { useSelector } from 'react-redux'
import { selectBehaviourSettings } from 'selectors/mainView'
import { Box, Checkbox, FormControlLabel } from '@material-ui/core'
import { FormContext } from 'contexts/FormContext'
import { BehaviourSettings } from 'config/constants/editorSettings'
import { TranslationContext } from 'contexts/TranslationContext'

export const BehaviourSettingsPanel = memo(() => {
  const { handleInput } = useContext(FormContext)
  const behaviourSettings = useSelector(selectBehaviourSettings)
  const { t } = useContext(TranslationContext)

  return (
    <Box width="100%">
      <form className="behaviour-settings">
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.setTimecodeFormatBasedOnMedia}
              checked={Boolean(behaviourSettings[BehaviourSettings.setTimecodeFormatBasedOnMedia])}
            />
          )}
          label={t('BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.muteAudioAtCreatedLayers}
              checked={Boolean(behaviourSettings[BehaviourSettings.muteAudioAtCreatedLayers])}
            />
          )}
          label={t('MUTE_AUDIO_AT_CREATED_LAYERS')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.preventVideoAddToTimelineOnMismatch}
              checked={Boolean(behaviourSettings[BehaviourSettings.preventVideoAddToTimelineOnMismatch])}
            />
          )}
          label={t('VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.askProjectNameOnNewProject}
              checked={Boolean(behaviourSettings[BehaviourSettings.askProjectNameOnNewProject])}
            />
          )}
          label={t('ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.addFirstImportAtStartTC}
              checked={Boolean(behaviourSettings[BehaviourSettings.addFirstImportAtStartTC])}
            />
          )}
          label={t('ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.allowTimelineAndMediaLayoutChange}
              checked={Boolean(behaviourSettings[BehaviourSettings.allowTimelineAndMediaLayoutChange])}
            />
          )}
          label={t('ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.useModalDialogForImportLocalFiles}
              checked={Boolean(behaviourSettings[BehaviourSettings.useModalDialogForImportLocalFiles])}
            />
          )}
          label={t('USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.preventAddVideoFilesWDiffVideoEncoderParams}
              checked={Boolean(behaviourSettings[BehaviourSettings.preventAddVideoFilesWDiffVideoEncoderParams])}
            />
          )}
          label={t('PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.ignoreQuantizerVideoParamsMismatch}
              checked={Boolean(behaviourSettings[BehaviourSettings.ignoreQuantizerVideoParamsMismatch])}
            />
          )}
          label={t('IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={BehaviourSettings.autoPlaySelectedMedia}
              checked={Boolean(behaviourSettings[BehaviourSettings.autoPlaySelectedMedia])}
            />
          )}
          label={t('AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING')}
        />
      </form>
    </Box>
  )
})
